import { useCallback, useContext, useEffect } from 'react';

import usePrevious from '@swf/core/hooks/usePrevious';
import { PokerContext } from '@swf/poker';

const usePollClubInfo = () => {
  const {
    state: { activeGameIds, fetchService },
    setState
  } = useContext(PokerContext);
  const previousIsGameOpen = usePrevious(activeGameIds);

  const fetchClubInfo = useCallback(() => {
    fetchService('userClubsAndGames');
  }, [fetchService]);

  useEffect(() => {
    setState((prevState) => ({ ...prevState, isPolling: true }));

    return () => {
      setState((prevState) => ({ ...prevState, isPolling: false }));
    };
  }, [setState]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (!activeGameIds.length) {
      interval = setInterval(
        fetchClubInfo,
        60 * 1000 // every minute
      );

      if (previousIsGameOpen.length) {
        fetchClubInfo(); // Immediately fetch when closing a game
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [fetchClubInfo, fetchService, setState, activeGameIds.length, previousIsGameOpen]);
};

export default usePollClubInfo;
